moment = require("moment")

DashboardService = ($http, $q, ScoreCardAPIService) ->
  prepareParams = (options) ->
    _.pickBy
      from: (options.from.format("YYYY-MM-DD") if options.from)
      to: (options.to.format("YYYY-MM-DD") if options.to)
      round_type: options.round_type?.join(',')
    , (v) -> v != null && v != undefined

  getHistories: (options = {}) ->
    delay = $q.defer()
    params = prepareParams(options)
    $http.get("/api/score_cards/recent.json", params: params).then (resp) ->
      delay.resolve resp.data
    delay.promise

  getBestScores: (options = {}) ->
    delay = $q.defer()
    params = prepareParams(options)
    $http.get("/api/score_cards/best_scores.json", params: params).then (resp) ->
      delay.resolve resp.data
    delay.promise

  getFavoriteCourses: (options = {}) ->
    delay = $q.defer()
    params = prepareParams(options)
    $http.get("/api/courses/most_played.json", params: params).then (resp) ->
      delay.resolve resp.data
    delay.promise

  getTopFairwayHitCourses: (options = {}) ->
    delay = $q.defer()
    params = prepareParams(options)
    $http.get("/api/courses/top_fairway_hit.json", params: params).then (resp) ->
      delay.resolve resp.data
    delay.promise

DashboardService.$inject = [
  '$http'
  '$q'
  'ScoreCardAPIService'
]

module.exports = DashboardService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/dashboard-service.coffee